export default "__VITE_ASSET__D6slhX46__"